import React, { useEffect, useMemo, useState } from "react";
import NonlalinService from "../../services/nonlalin/NonlalinService";

const NonlalinStatus = ({kodeStatus}) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [uraianStatus, setUraianStatus] = useState('')

    useEffect(() => {
        const getStatusDok = async () => {
            const response = await nonLalinService.getRefNonlalinStatus(kodeStatus)
            setUraianStatus(response.data.uraianStatus)
        }
        getStatusDok()
    }, [nonLalinService, kodeStatus])

    return (
        <>
            {uraianStatus}
        </>
    )
}

export default NonlalinStatus